import React from 'react';
import DateInput from 'shared/components/ui/DateInput';

/** Date-only filter value editor (no time portion in the picker UI). */
export default function FilterDateInput({
  value,
  onChange,
  inputClassName = '',
  className = '',
  onClick,
  disabled,
}) {
  return (
    <DateInput
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={className}
      inputClassName={inputClassName}
      onClick={onClick}
      disabled={disabled}
    />
  );
}
